import { render, staticRenderFns } from "./ThirdStep2.vue?vue&type=template&id=08538995&"
import script from "./ThirdStep2.vue?vue&type=script&lang=js&"
export * from "./ThirdStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports